// eslint-disable-next-line no-shadow
export enum ParetoSections {
  // eslint-disable-next-line no-unused-vars
  top20 = '20%',
  // eslint-disable-next-line no-unused-vars
  bottom80 = '80%',
}
